import React from 'react';
import PlatformDetailPage from './PlatformDetailPage';

const MSPConnectPage = () => <PlatformDetailPage platformId="mspconnect" />;

export default MSPConnectPage;
